import angular from 'angular';
import _ from 'lodash-es';
import templateModalRepre from '~/components/repre/modals/modal-repre.html';
import ModalRepreController from '~/components/repre/modals/modal-repre.controller';
import templateModalDroit from '~/components/droit/modal/modal-droit.html';
import ModalDroitController from '~/components/droit/modal/modal-droit.controller';
import templateModalQueryJson from '../query-editor/modal/modal-query-json.html';
import ModalQueryJsonController from '../query-editor/modal/modal-query-json.controller';
import templateModalQueryPhp from '../query-editor/modal/modal-query-php.html';
import ModalQueryPhpController from '../query-editor/modal/modal-query-php.controller';

export default class QueryToolbarController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} NodeService
	 */
	constructor(
		$timeout,
		$translate,
		$uibModal,
		NodeService,
	) {
		this.$timeout = $timeout;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.datePickerOptions = {
			allowInput:        true,
			altFormat:         'd/m/Y H:i:S',
			dateFormat:        'd/m/Y H:i:S',
			displayInput:      true,
			enableTime:        true,
			label:             $translate.instant('common.date'),
			parseDate:         (
				/** @type {Date|string} */ d,
			) => Number.isNaN(d) || d === 'Invalid Date' ? new Date() : new Date(d),
			placeholder:       $translate.instant('common.now'),
			static:            true,
			time_24hr:         true,
		};

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;
		this.exporting = false;
	}

	/**
	 * Edits query rights (open modal)
	 */
	async editDroits() {
		const newNode = await this.$uibModal.open({
			ariaLabelledBy:  'modal-droit-title',
			ariaDescribedBy: 'modal-droit-body',
			template:        templateModalDroit,
			controller:      ModalDroitController,
			controllerAs:    '$ctrl',
			resolve:         {
				node: () => this.editor?.tab?.node,
				edit: () => this.editor?.tab?.edit,
			},
			size:            'lg',
		}).result;

		if (newNode) {
			_.merge(this.editor?.tab?.node.droit, newNode.droit);
			this.editor?.queryEditorForm?.$setDirty();
		}
	}

	exportDocs() {
		this.$timeout(async () => {
			this.exporting = true;
			await this.editor?.exportDocs();
			this.exporting = false;
		});
	}

	exportToExcel() {
		(async () => {
			this.exporting = true;
			await this.editor?.exportToExcel();
			this.$timeout(() => {
				this.exporting = false;
			});
		})();
	}

	async openJSON() {
		// eslint-disable-next-line no-console
		console.log('query', this.editor?.tab?.query);
		const result = await this.$uibModal.open({
			template:     templateModalQueryJson,
			controller:   ModalQueryJsonController,
			controllerAs: '$ctrl',
			size:         'lg',
			resolve:      {
				query: () => this.editor?.tab?.query.export(),
			},
		}).result;
		if (result) {
			this.editor?.tab?.export();
		}
	}

	openPHP() {
		this.$uibModal.open({
			template:     templateModalQueryPhp,
			controller:   ModalQueryPhpController,
			controllerAs: '$ctrl',
			size:         'lg',
			resolve:      {
				query: () => this.editor?.tab?.query.export(),
			},
		});
	}

	/**
	 * Display the repre of the workflow for edition
	 */
	async repreEdit() {
		try {
			const result = await this.$uibModal.open({
				ariaLabelledBy:  'modal-repre-title',
				ariaDescribedBy: 'modal-repre-body',
				template:        templateModalRepre,
				controller:      ModalRepreController,
				controllerAs:    '$ctrl',
				resolve:         {
					repre: () => this.editor?.tab?.node.repre,
				},
			}).result;

			if (this.editor?.tab && !angular.equals(result.repre, this.editor.tab.node.repre)) {
				_.merge(this.editor?.tab?.node.repre, result.repre);
				this.editor.tab.node.name = this.editor.tab.node.getName(true);
				this.editor?.queryEditorForm?.$setDirty();
			}
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	setName() {
		this.editor?.tab?.node.setName(this.editor?.tab?.node.name || '');
		this.editor?.queryEditorForm?.$setDirty();
	}

	setDirty() {
		this.editor?.queryEditorForm?.$setDirty();
	}
}
